const selectors = {
  accordion: '[data-accordion]',
  trigger: '[data-accordion-trigger]',
}

const classes = {
  isOpen: 'active',
}

const elements = {
  accordion: null,
}

const accordionInit = () => {
  elements.accordion = document.querySelectorAll(selectors.accordion)

  if (!elements.accordion) return null
  ;[...elements.accordion].map((element) => {
    const trigger = element.querySelector(selectors.trigger)

    if (!trigger) return null
    trigger.addEventListener('click', () => element.classList[element.classList.contains(classes.isOpen) ? 'remove' : 'add'](classes.isOpen))
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    accordionInit()
  },
  {
    once: true,
  }
)
